export const generatedSourceUseReviewPacket = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-20T00:00:00.000Z",
  "mode": "deterministic-source-use-review-packets",
  "operatingRule": "Review packets are workflow artifacts, not legal clearance. They make source-use decisions explicit and fail closed until terms/license evidence, citation policy, redistribution scope, provider-endorsement boundary, and reviewer approval are captured.",
  "sourceUseRightsLedgerHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
  "sourceCount": 33,
  "packetCount": 33,
  "blockedPacketCount": 33,
  "customerUseAllowed": false,
  "rawRedistributionAllowed": false,
  "riskCounts": {
    "medium": 31,
    "high": 2
  },
  "priorityCounts": {
    "P2": 31,
    "P0": 2
  },
  "evidenceHashes": {
    "sourceRegistry": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
    "sourceIngestionLedger": "sha256-0e4319b9702f975d686339d93606beee2b5e4eca89d04e721b2ecf61493690c2",
    "sourcePromotionLedger": "sha256-bace1b5a9aa61005c905a21ed0714a8068faf28be32f08faa09acdf95f9c3fa4",
    "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57"
  },
  "globalReviewOutputsRequired": [
    "source-specific terms/license hash",
    "approved citation text and attribution policy",
    "raw payload redistribution decision",
    "derived normalized record customer-use decision",
    "provider endorsement/trademark boundary",
    "named reviewer and review timestamp"
  ],
  "reviewQueue": [
    {
      "id": "source-use-review-nasa-clps",
      "sourceId": "nasa-clps",
      "title": "Commercial Lunar Payload Services",
      "sourceUseClass": "commercial-public-source",
      "riskLevel": "high",
      "priority": "P0",
      "requiredDecisionCount": 6,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-4b3395cfcc70a4f4f0a78c7a0a54b16160a9808c0a58cd586d5085adf8dc28d7"
    },
    {
      "id": "source-use-review-spacex-rideshare",
      "sourceId": "spacex-rideshare",
      "title": "SpaceX Rideshare Program",
      "sourceUseClass": "commercial-public-source",
      "riskLevel": "high",
      "priority": "P0",
      "requiredDecisionCount": 6,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-9a7afed2d2517e5a7f3d6c0bb9dd58febf2fc8b7d3fe1236721d849b201c8d13"
    },
    {
      "id": "source-use-review-cad-api",
      "sourceId": "cad-api",
      "title": "SBDB Close Approach Data API",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 5,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-5509ae5af4c25dc7a954e49ebf73395ea3b8195d3da643c0fdb45929575e9245"
    },
    {
      "id": "source-use-review-cantera",
      "sourceId": "cantera",
      "title": "Cantera",
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 5,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-f8c02fcec876f0727bd2a3dd2898bfa468e397fbb04f5211bbbbcca27945f453"
    },
    {
      "id": "source-use-review-ccsds",
      "sourceId": "ccsds",
      "title": "Consultative Committee for Space Data Systems",
      "sourceUseClass": "standards-body-source",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 6,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-983afbacdf83a228cfa1c6fc2db8b2e2d02a058bae244539d7326936b048a586"
    },
    {
      "id": "source-use-review-dymos",
      "sourceId": "dymos",
      "title": "Dymos",
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 5,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-bbb82d5f622f7f7eb5a78f80d1e8b80fdb03389aad50e04f770de8b208121835"
    },
    {
      "id": "source-use-review-esa-psa",
      "sourceId": "esa-psa",
      "title": "ESA Planetary Science Archive",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 5,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-290b747abe1952a3fa6bccb68dc75cdfca50f9c3cb2aed84fa46dea4255e8cf1"
    },
    {
      "id": "source-use-review-gmat",
      "sourceId": "gmat",
      "title": "General Mission Analysis Tool",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 5,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-47fd3f4d01a3bf3328f0b2526ec78e45d9926230622c06be17e95b12b2beb6cf"
    },
    {
      "id": "source-use-review-horizons-api",
      "sourceId": "horizons-api",
      "title": "JPL Horizons API",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 5,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-c7e8a1108b028d154dbf2c958d29a047f2eec0008756d0ab200f0f4bab9f846d"
    },
    {
      "id": "source-use-review-horizons-mercury-2024",
      "sourceId": "horizons-mercury-2024",
      "title": "JPL Horizons Mercury Physical Data",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 5,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-89a8b926ccad44332935ad8da2b18b72057f989eab7b5371f457e777deb22f47"
    },
    {
      "id": "source-use-review-iau-sofa",
      "sourceId": "iau-sofa",
      "title": "Standards of Fundamental Astronomy",
      "sourceUseClass": "standards-body-source",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 6,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-d708b33e51018c98e44e6a3085ff6f4c51e38614caffb6288056764601deb5b8"
    },
    {
      "id": "source-use-review-jaxa-darts",
      "sourceId": "jaxa-darts",
      "title": "DARTS Space Science Data Archive",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 5,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-8ccd8569fecc8f4613889fcebbdbe701b35a7d5bee39814795953aabed09ff24"
    },
    {
      "id": "source-use-review-materials-project",
      "sourceId": "materials-project",
      "title": "Materials Project API",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 5,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-4596c7e86467c7e6d0114d13df988db5a8376ff3ee9a04436f439191d0725ec5"
    },
    {
      "id": "source-use-review-moose-framework",
      "sourceId": "moose-framework",
      "title": "MOOSE Framework",
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 5,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-091da51fce102c99c05e3b43636be9a9a0d0b709fbd0950ae741ad065156e656"
    },
    {
      "id": "source-use-review-mpc",
      "sourceId": "mpc",
      "title": "Minor Planet Center Data",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 5,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-b4cfe2b9062349c13cb2246334bac86f342028f68366ad06441885d3dbdca089"
    },
    {
      "id": "source-use-review-nasa-ccmc",
      "sourceId": "nasa-ccmc",
      "title": "Community Coordinated Modeling Center",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 5,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-e9a3d92fa64992efdc7fcd16e058bcba03901b7b55667aa734eb373f75eed5fc"
    },
    {
      "id": "source-use-review-nasa-cost-estimating-handbook",
      "sourceId": "nasa-cost-estimating-handbook",
      "title": "NASA Cost Estimating Handbook",
      "sourceUseClass": "general-public-source",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 5,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-56e69f036d914287fffd6d66631a065e6bae4dc48c8dd420b5c3c9d31774dd55"
    },
    {
      "id": "source-use-review-nasa-dtn",
      "sourceId": "nasa-dtn",
      "title": "Delay/Disruption Tolerant Networking",
      "sourceUseClass": "general-public-source",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 5,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-c24176e150bbc8dc054a8589b85d3bd909855ac7f98e60e599656d03cb6cddb0"
    },
    {
      "id": "source-use-review-nasa-mercury",
      "sourceId": "nasa-mercury",
      "title": "Mercury Facts",
      "sourceUseClass": "general-public-source",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 5,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-2b18f1330f735b5a1dba1b6057e6d3a7b7a31a346b0465a16e42f15280c598a7"
    },
    {
      "id": "source-use-review-nasa-se-handbook",
      "sourceId": "nasa-se-handbook",
      "title": "NASA Systems Engineering Handbook",
      "sourceUseClass": "general-public-source",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 5,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-18529ac1902153e21a0a88567f0f81981664a8cc38ffe88ec4d78dacf1174d96"
    },
    {
      "id": "source-use-review-nasa-spdf",
      "sourceId": "nasa-spdf",
      "title": "NASA Space Physics Data Facility",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 5,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-32c8135a41eab812aca7cd4d453b5cb352916ef453402ec0e20d158272024292"
    },
    {
      "id": "source-use-review-nist-chemistry-webbook",
      "sourceId": "nist-chemistry-webbook",
      "title": "NIST Chemistry WebBook SRD 69",
      "sourceUseClass": "standards-body-source",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 6,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-bc9c8a83702c167dc0dd82441e737366ee8b2330e009377b2b84f33256bbf71e"
    },
    {
      "id": "source-use-review-nist-codata",
      "sourceId": "nist-codata",
      "title": "2022 CODATA Fundamental Physical Constants",
      "sourceUseClass": "general-public-source",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 5,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-08dfe434aa64c5586595c9c0756846c32a7c12e7ae3da2241191520fc0888a2c"
    },
    {
      "id": "source-use-review-noaa-swpc",
      "sourceId": "noaa-swpc",
      "title": "NOAA Space Weather Prediction Center Products and Data",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 5,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-8286e8566447f45bb575f58049ee4b072c3969ecf091c32ce69e6015ba6b4b39"
    },
    {
      "id": "source-use-review-openfoam",
      "sourceId": "openfoam",
      "title": "OpenFOAM",
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 5,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-f266f1115629723670abec47ba0b67c47760f49e4f07ba4a28621447372660b9"
    },
    {
      "id": "source-use-review-openmdao",
      "sourceId": "openmdao",
      "title": "OpenMDAO",
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 5,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-497bf8d836bf57f9e008433cca02f11f6b1b622ac0ed4670a75aa552ab2e9873"
    },
    {
      "id": "source-use-review-orekit",
      "sourceId": "orekit",
      "title": "Orekit",
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 5,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-1f5b8233a9afddb4ddfef51cae9d77e1ef08dee96d95b45ec77aa90f4501cf81"
    },
    {
      "id": "source-use-review-pds",
      "sourceId": "pds",
      "title": "Planetary Data System",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 5,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-00e966c618c18e5308d81fb4ca949c494a67bd76d003fd0bb212d97e05601f97"
    },
    {
      "id": "source-use-review-sbdb-api",
      "sourceId": "sbdb-api",
      "title": "JPL Small-Body Database API",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 5,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-864ee676bdb8775aef26465d616689e9bb7a128b3d4b264da6f5a129434d3023"
    },
    {
      "id": "source-use-review-sec-edgar",
      "sourceId": "sec-edgar",
      "title": "SEC EDGAR",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 5,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-a1685dc32f2dd10822435e58b6aec9affcb7345f5e6c7f484161306061f35a14"
    },
    {
      "id": "source-use-review-spice-gf",
      "sourceId": "spice-gf",
      "title": "SPICE Geometry Finder",
      "sourceUseClass": "standards-body-source",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 6,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-4281f3c67a8a6ab25a5330221f9fdcb09caee9a65460e185b666addffcb162a6"
    },
    {
      "id": "source-use-review-tudat",
      "sourceId": "tudat",
      "title": "Tudat Space / TudatPy",
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 5,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-0a1ac8eca9fa1943fb5488a535f824daf549e233a37a60243106a9f2e3ccfffe"
    },
    {
      "id": "source-use-review-usaspending",
      "sourceId": "usaspending",
      "title": "USAspending.gov",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "requiredDecisionCount": 5,
      "blockerCount": 6,
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-44dc86020821ef71a9993b152b34d63c070a75752412776ee7bc52820d1b2f03"
    }
  ],
  "packets": [
    {
      "id": "source-use-review-spice-gf",
      "sourceId": "spice-gf",
      "title": "SPICE Geometry Finder",
      "organization": "NASA NAIF",
      "url": "https://naif.jpl.nasa.gov/pub/naif/toolkit_docs/C/req/gf.html",
      "trust": "primary",
      "sourceType": "ephemeris-event-software",
      "sourceUseClass": "standards-body-source",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-97d74c96",
      "sourceUseHash": "sha256-57a8f1ccad068b602d4b88e7d82356212d59c341fa186ae3100b2a3ca6bfbcf8",
      "sourceRegistryHash": "fnv1a32-97d74c96",
      "requiredRightsArtifacts": [
        "standard identifier and version",
        "license or public-access terms note",
        "citation format",
        "review of reproduction limits for tables, figures, and long excerpts"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "NASA NAIF",
        "title": "SPICE Geometry Finder",
        "url": "https://naif.jpl.nasa.gov/pub/naif/toolkit_docs/C/req/gf.html",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-97d74c96",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Use standard identifiers and short references; do not embed protected standards text without rights review.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Kernel set, target/observer/constraint, tolerance, and generated window hash required.",
        "uncertaintyMode": "Kernel coverage plus geometric tolerance.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-4281f3c67a8a6ab25a5330221f9fdcb09caee9a65460e185b666addffcb162a6"
    },
    {
      "id": "source-use-review-horizons-api",
      "sourceId": "horizons-api",
      "title": "JPL Horizons API",
      "organization": "NASA/JPL",
      "url": "https://ssd-api.jpl.nasa.gov/doc/horizons.html",
      "trust": "primary",
      "sourceType": "ephemeris-api",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-9335c241",
      "sourceUseHash": "sha256-634f1bc644a849f1d3fa19ab9c7c54e099c6bfa01405b82381d39f1047e998ab",
      "sourceRegistryHash": "fnv1a32-9335c241",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": false,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "NASA/JPL",
        "title": "JPL Horizons API",
        "url": "https://ssd-api.jpl.nasa.gov/doc/horizons.html",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-9335c241",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Full Horizons query string and response timestamp required.",
        "uncertaintyMode": "API table tolerance plus downstream numeric tolerance.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-c7e8a1108b028d154dbf2c958d29a047f2eec0008756d0ab200f0f4bab9f846d"
    },
    {
      "id": "source-use-review-horizons-mercury-2024",
      "sourceId": "horizons-mercury-2024",
      "title": "JPL Horizons Mercury Physical Data",
      "organization": "NASA/JPL Horizons",
      "url": "https://ssd.jpl.nasa.gov/api/horizons.api?format=json&COMMAND=%27199%27&OBJ_DATA=%27YES%27&MAKE_EPHEM=%27NO%27",
      "trust": "primary",
      "sourceType": "body-physical-data",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-5b941f40",
      "sourceUseHash": "sha256-12eeea9d4632e292d07a977508a77eff9ec4992106e30a5f7cdf0fb307a33acf",
      "sourceRegistryHash": "fnv1a32-5b941f40",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": false,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "NASA/JPL Horizons",
        "title": "JPL Horizons Mercury Physical Data",
        "url": "https://ssd.jpl.nasa.gov/api/horizons.api?format=json&COMMAND=%27199%27&OBJ_DATA=%27YES%27&MAKE_EPHEM=%27NO%27",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-5b941f40",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Body-data query and retrieved physical constants required.",
        "uncertaintyMode": "Source-body data plus formula tolerance.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-89a8b926ccad44332935ad8da2b18b72057f989eab7b5371f457e777deb22f47"
    },
    {
      "id": "source-use-review-nist-codata",
      "sourceId": "nist-codata",
      "title": "2022 CODATA Fundamental Physical Constants",
      "organization": "NIST",
      "url": "https://physics.nist.gov/cuu/Constants/Table/allascii.txt",
      "trust": "primary",
      "sourceType": "physical-constants",
      "sourceUseClass": "general-public-source",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-333cff52",
      "sourceUseHash": "sha256-0cc3a1436931190c0a07c880c51c5aa65b06e78d7a215e22669f69f07f6a9b5a",
      "sourceRegistryHash": "fnv1a32-333cff52",
      "requiredRightsArtifacts": [
        "terms or license note",
        "citation format",
        "access timestamp",
        "reviewer approval"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": false,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "NIST",
        "title": "2022 CODATA Fundamental Physical Constants",
        "url": "https://physics.nist.gov/cuu/Constants/Table/allascii.txt",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-333cff52",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Treat as citation-only planning evidence until source-specific terms are reviewed.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Constants release and exact constant identifiers required.",
        "uncertaintyMode": "CODATA uncertainty or exact-SI status.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-08dfe434aa64c5586595c9c0756846c32a7c12e7ae3da2241191520fc0888a2c"
    },
    {
      "id": "source-use-review-sbdb-api",
      "sourceId": "sbdb-api",
      "title": "JPL Small-Body Database API",
      "organization": "NASA/JPL",
      "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
      "trust": "primary",
      "sourceType": "small-body-orbit-api",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-93c0fe91",
      "sourceUseHash": "sha256-a10ef09edab1a69fc6e05ed4a0e463eaa6d6aaf964d9712d6953716a02792e3b",
      "sourceRegistryHash": "fnv1a32-93c0fe91",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": false,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "NASA/JPL",
        "title": "JPL Small-Body Database API",
        "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-93c0fe91",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
        "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-864ee676bdb8775aef26465d616689e9bb7a128b3d4b264da6f5a129434d3023"
    },
    {
      "id": "source-use-review-cad-api",
      "sourceId": "cad-api",
      "title": "SBDB Close Approach Data API",
      "organization": "NASA/JPL CNEOS",
      "url": "https://ssd-api.jpl.nasa.gov/doc/cad.html",
      "trust": "primary",
      "sourceType": "close-approach-api",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-ba0c45bb",
      "sourceUseHash": "sha256-62d5fd81325c14b2bdbf7f978f1f17863dde84034fbdc040bb41daffe39c1a42",
      "sourceRegistryHash": "fnv1a32-ba0c45bb",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": false,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "NASA/JPL CNEOS",
        "title": "SBDB Close Approach Data API",
        "url": "https://ssd-api.jpl.nasa.gov/doc/cad.html",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-ba0c45bb",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Date range, distance threshold, sort order, and close-approach record hash required.",
        "uncertaintyMode": "Nominal approach values with orbit-solution caveats.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-5509ae5af4c25dc7a954e49ebf73395ea3b8195d3da643c0fdb45929575e9245"
    },
    {
      "id": "source-use-review-orekit",
      "sourceId": "orekit",
      "title": "Orekit",
      "organization": "CS Group / open source community",
      "url": "https://www.orekit.org/",
      "trust": "open-source",
      "sourceType": "astrodynamics-library",
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-88a8d672",
      "sourceUseHash": "sha256-df79afad6216381464b72fba5c94f119b314989cf6fc060d31a4dfcf4cbfe0e2",
      "sourceRegistryHash": "fnv1a32-88a8d672",
      "requiredRightsArtifacts": [
        "license file or SPDX identifier",
        "dependency version and repository URL",
        "notice/attribution requirement",
        "copyleft or redistribution compatibility review"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": false,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "CS Group / open source community",
        "title": "Orekit",
        "url": "https://www.orekit.org/",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-88a8d672",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Do not bundle, modify, or redistribute tool code/artifacts until the specific license and notices are captured.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Tool version, data context, frames, force model, and checksums required.",
        "uncertaintyMode": "Model configuration and independent comparison residuals.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-1f5b8233a9afddb4ddfef51cae9d77e1ef08dee96d95b45ec77aa90f4501cf81"
    },
    {
      "id": "source-use-review-gmat",
      "sourceId": "gmat",
      "title": "General Mission Analysis Tool",
      "organization": "NASA",
      "url": "https://software.nasa.gov/software/GSC-17177-1",
      "trust": "primary",
      "sourceType": "mission-analysis-tool",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-3743e565",
      "sourceUseHash": "sha256-640eb6ce03eab0fee2e7a93ec615a4538c492bce831462ab13a2b19ab82212b5",
      "sourceRegistryHash": "fnv1a32-3743e565",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": false,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "NASA",
        "title": "General Mission Analysis Tool",
        "url": "https://software.nasa.gov/software/GSC-17177-1",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-3743e565",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "GMAT script hash, version, force model, optimizer, and run summary required.",
        "uncertaintyMode": "Constraint residuals and cross-tool comparison.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-47fd3f4d01a3bf3328f0b2526ec78e45d9926230622c06be17e95b12b2beb6cf"
    },
    {
      "id": "source-use-review-openmdao",
      "sourceId": "openmdao",
      "title": "OpenMDAO",
      "organization": "NASA",
      "url": "https://openmdao.org/",
      "trust": "primary",
      "sourceType": "optimization-framework",
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-9ef7d3cb",
      "sourceUseHash": "sha256-527154357d0a395242916a3a43246c58e5fb556ade38cc917e14228ddeea7abf",
      "sourceRegistryHash": "fnv1a32-9ef7d3cb",
      "requiredRightsArtifacts": [
        "license file or SPDX identifier",
        "dependency version and repository URL",
        "notice/attribution requirement",
        "copyleft or redistribution compatibility review"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": false,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "NASA",
        "title": "OpenMDAO",
        "url": "https://openmdao.org/",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-9ef7d3cb",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Do not bundle, modify, or redistribute tool code/artifacts until the specific license and notices are captured.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Problem definition, design variables, constraints, objective, and seed required.",
        "uncertaintyMode": "Sensitivity and optimizer-convergence metadata.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-497bf8d836bf57f9e008433cca02f11f6b1b622ac0ed4670a75aa552ab2e9873"
    },
    {
      "id": "source-use-review-dymos",
      "sourceId": "dymos",
      "title": "Dymos",
      "organization": "OpenMDAO project",
      "url": "https://openmdao.github.io/dymos/",
      "trust": "open-source",
      "sourceType": "optimal-control-library",
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-31dbd31c",
      "sourceUseHash": "sha256-fffae5de932bec6e92a8d52b83686a2b6ab47f5232fbbd5fd1a100064d90de86",
      "sourceRegistryHash": "fnv1a32-31dbd31c",
      "requiredRightsArtifacts": [
        "license file or SPDX identifier",
        "dependency version and repository URL",
        "notice/attribution requirement",
        "copyleft or redistribution compatibility review"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": false,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "OpenMDAO project",
        "title": "Dymos",
        "url": "https://openmdao.github.io/dymos/",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-31dbd31c",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Do not bundle, modify, or redistribute tool code/artifacts until the specific license and notices are captured.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Problem definition, transcription, optimizer, constraints, objective, and run seed required.",
        "uncertaintyMode": "Convergence status, sensitivity, and collocation residuals.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-bbb82d5f622f7f7eb5a78f80d1e8b80fdb03389aad50e04f770de8b208121835"
    },
    {
      "id": "source-use-review-tudat",
      "sourceId": "tudat",
      "title": "Tudat Space / TudatPy",
      "organization": "TU Delft Astrodynamics Toolbox community",
      "url": "https://docs.tudat.space/en/latest/",
      "trust": "open-source",
      "sourceType": "astrodynamics-toolkit",
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-c238f1d2",
      "sourceUseHash": "sha256-a3b4f73cdfc87599c32e25fc0d2e30bf82bc9d713c9c8de3facf1ed8355ad843",
      "sourceRegistryHash": "fnv1a32-c238f1d2",
      "requiredRightsArtifacts": [
        "license file or SPDX identifier",
        "dependency version and repository URL",
        "notice/attribution requirement",
        "copyleft or redistribution compatibility review"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": false,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "TU Delft Astrodynamics Toolbox community",
        "title": "Tudat Space / TudatPy",
        "url": "https://docs.tudat.space/en/latest/",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-c238f1d2",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Do not bundle, modify, or redistribute tool code/artifacts until the specific license and notices are captured.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Tool version, body settings, integrator, propagator, and output hashes required.",
        "uncertaintyMode": "Integrator settings, model configuration, and cross-tool residual bounds.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-0a1ac8eca9fa1943fb5488a535f824daf549e233a37a60243106a9f2e3ccfffe"
    },
    {
      "id": "source-use-review-iau-sofa",
      "sourceId": "iau-sofa",
      "title": "Standards of Fundamental Astronomy",
      "organization": "IAU SOFA",
      "url": "https://www.iausofa.org/",
      "trust": "primary",
      "sourceType": "astronomy-standards",
      "sourceUseClass": "standards-body-source",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-2a854c84",
      "sourceUseHash": "sha256-c1fc511b99907ba9fd2367df76679f7522e8eedd8f3e8944b4d6e31313cb88be",
      "sourceRegistryHash": "fnv1a32-2a854c84",
      "requiredRightsArtifacts": [
        "standard identifier and version",
        "license or public-access terms note",
        "citation format",
        "review of reproduction limits for tables, figures, and long excerpts"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "IAU SOFA",
        "title": "Standards of Fundamental Astronomy",
        "url": "https://www.iausofa.org/",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-2a854c84",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Use standard identifiers and short references; do not embed protected standards text without rights review.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Routine/version reference and transformation chain required.",
        "uncertaintyMode": "Standards conformance and transform precision.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-d708b33e51018c98e44e6a3085ff6f4c51e38614caffb6288056764601deb5b8"
    },
    {
      "id": "source-use-review-pds",
      "sourceId": "pds",
      "title": "Planetary Data System",
      "organization": "NASA",
      "url": "https://pds.nasa.gov/datasearch/data-search/",
      "trust": "primary",
      "sourceType": "mission-data-archive",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-7c477cc2",
      "sourceUseHash": "sha256-f43ee31285ff21cd83d07c4271839c8ed49107622706aeea80f77e800c2b2652",
      "sourceRegistryHash": "fnv1a32-7c477cc2",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": false,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "NASA",
        "title": "Planetary Data System",
        "url": "https://pds.nasa.gov/datasearch/data-search/",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-7c477cc2",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
        "uncertaintyMode": "Instrument/product calibration metadata.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-00e966c618c18e5308d81fb4ca949c494a67bd76d003fd0bb212d97e05601f97"
    },
    {
      "id": "source-use-review-mpc",
      "sourceId": "mpc",
      "title": "Minor Planet Center Data",
      "organization": "International Astronomical Union Minor Planet Center",
      "url": "https://minorplanetcenter.net/data",
      "trust": "primary",
      "sourceType": "small-body-observation-archive",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-62694497",
      "sourceUseHash": "sha256-d6603a5739948b62381ecda8f42c02a966328a5b6599902b78bd4ca6a90fb1d2",
      "sourceRegistryHash": "fnv1a32-62694497",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": false,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "International Astronomical Union Minor Planet Center",
        "title": "Minor Planet Center Data",
        "url": "https://minorplanetcenter.net/data",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-62694497",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
        "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-b4cfe2b9062349c13cb2246334bac86f342028f68366ad06441885d3dbdca089"
    },
    {
      "id": "source-use-review-esa-psa",
      "sourceId": "esa-psa",
      "title": "ESA Planetary Science Archive",
      "organization": "European Space Agency",
      "url": "https://archives.esac.esa.int/psa/",
      "trust": "primary",
      "sourceType": "planetary-mission-archive",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-5c0abe4d",
      "sourceUseHash": "sha256-cf3a2609993fae8446f717c9b51ba0016ec3893ebf788cfe0b4b48ca0c115b44",
      "sourceRegistryHash": "fnv1a32-5c0abe4d",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": false,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "European Space Agency",
        "title": "ESA Planetary Science Archive",
        "url": "https://archives.esac.esa.int/psa/",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-5c0abe4d",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
        "uncertaintyMode": "Product calibration, processing level, and instrument caveats.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-290b747abe1952a3fa6bccb68dc75cdfca50f9c3cb2aed84fa46dea4255e8cf1"
    },
    {
      "id": "source-use-review-jaxa-darts",
      "sourceId": "jaxa-darts",
      "title": "DARTS Space Science Data Archive",
      "organization": "ISAS/JAXA",
      "url": "https://darts.isas.jaxa.jp/",
      "trust": "primary",
      "sourceType": "space-science-archive",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-e07b656d",
      "sourceUseHash": "sha256-9f8a54aebe3282c2c5fb96c5673305f9ecf04331cf10fc630be87e697038b8dc",
      "sourceRegistryHash": "fnv1a32-e07b656d",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": false,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "ISAS/JAXA",
        "title": "DARTS Space Science Data Archive",
        "url": "https://darts.isas.jaxa.jp/",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-e07b656d",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
        "uncertaintyMode": "Dataset calibration and archive release notes.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-8ccd8569fecc8f4613889fcebbdbe701b35a7d5bee39814795953aabed09ff24"
    },
    {
      "id": "source-use-review-nasa-mercury",
      "sourceId": "nasa-mercury",
      "title": "Mercury Facts",
      "organization": "NASA Science",
      "url": "https://science.nasa.gov/mercury/facts/",
      "trust": "primary",
      "sourceType": "official-factsheet",
      "sourceUseClass": "general-public-source",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-78229f8d",
      "sourceUseHash": "sha256-7220d6133064aea0d8732df451938606ec8fa3f17cd86b08308cc182b758a11e",
      "sourceRegistryHash": "fnv1a32-78229f8d",
      "requiredRightsArtifacts": [
        "terms or license note",
        "citation format",
        "access timestamp",
        "reviewer approval"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": false,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "NASA Science",
        "title": "Mercury Facts",
        "url": "https://science.nasa.gov/mercury/facts/",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-78229f8d",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Treat as citation-only planning evidence until source-specific terms are reviewed.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Page URL, access date, and derived-calculation trace required.",
        "uncertaintyMode": "Factsheet summary caveats; not a substitute for mission data.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-2b18f1330f735b5a1dba1b6057e6d3a7b7a31a346b0465a16e42f15280c598a7"
    },
    {
      "id": "source-use-review-nasa-dtn",
      "sourceId": "nasa-dtn",
      "title": "Delay/Disruption Tolerant Networking",
      "organization": "NASA SCaN",
      "url": "https://www.nasa.gov/communicating-with-missions/delay-disruption-tolerant-networking/",
      "trust": "primary",
      "sourceType": "communications-program-reference",
      "sourceUseClass": "general-public-source",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-61e03fe6",
      "sourceUseHash": "sha256-1a7de1a7203b5facf55e1002995c1c12d9e096255991504e90609fd8b00f1ad7",
      "sourceRegistryHash": "fnv1a32-61e03fe6",
      "requiredRightsArtifacts": [
        "terms or license note",
        "citation format",
        "access timestamp",
        "reviewer approval"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": false,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "NASA SCaN",
        "title": "Delay/Disruption Tolerant Networking",
        "url": "https://www.nasa.gov/communicating-with-missions/delay-disruption-tolerant-networking/",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-61e03fe6",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Treat as citation-only planning evidence until source-specific terms are reviewed.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Program reference, architecture assumption, and scenario mapping required.",
        "uncertaintyMode": "Conceptual architecture until mission-specific link data exists.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-c24176e150bbc8dc054a8589b85d3bd909855ac7f98e60e599656d03cb6cddb0"
    },
    {
      "id": "source-use-review-spacex-rideshare",
      "sourceId": "spacex-rideshare",
      "title": "SpaceX Rideshare Program",
      "organization": "SpaceX",
      "url": "https://www.spacex.com/rideshare/",
      "trust": "commercial-primary",
      "sourceType": "commercial-launch-pricing",
      "sourceUseClass": "commercial-public-source",
      "riskLevel": "high",
      "priority": "P0",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-86aacff8",
      "sourceUseHash": "sha256-e8ca9a05bb0a4360b3f6a386245e9656c43d07ea998a13b602f09b0a5f0100d8",
      "sourceRegistryHash": "fnv1a32-86aacff8",
      "requiredRightsArtifacts": [
        "captured terms or legal page hash",
        "commercial quote/use boundary",
        "minimal excerpt policy",
        "reviewer approval before customer-facing numeric use"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "SpaceX",
        "title": "SpaceX Rideshare Program",
        "url": "https://www.spacex.com/rideshare/",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-86aacff8",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Do not redistribute raw page/API content; cite source and preserve derived normalized values only after terms review.",
      "reviewInputs": {
        "declaredLicenseNote": "Commercial public web page; quote minimally and preserve citation rather than redistributing raw content.",
        "queryPolicy": "Capture provider page, access timestamp, price table text, destination/orbit class, and terms caveats before use.",
        "uncertaintyMode": "Commercial list price caveats, mission-specific integration costs, schedule, destination, and contract terms.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-9a7afed2d2517e5a7f3d6c0bb9dd58febf2fc8b7d3fe1236721d849b201c8d13"
    },
    {
      "id": "source-use-review-nasa-clps",
      "sourceId": "nasa-clps",
      "title": "Commercial Lunar Payload Services",
      "organization": "NASA",
      "url": "https://www.nasa.gov/commercial-lunar-payload-services/",
      "trust": "primary",
      "sourceType": "commercial-lunar-delivery-program",
      "sourceUseClass": "commercial-public-source",
      "riskLevel": "high",
      "priority": "P0",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-7d151be6",
      "sourceUseHash": "sha256-e6b104bc250fb970a5a671bb87341936f58099195b93270240970c1f7b8eb1b2",
      "sourceRegistryHash": "fnv1a32-7d151be6",
      "requiredRightsArtifacts": [
        "captured terms or legal page hash",
        "commercial quote/use boundary",
        "minimal excerpt policy",
        "reviewer approval before customer-facing numeric use"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "NASA",
        "title": "Commercial Lunar Payload Services",
        "url": "https://www.nasa.gov/commercial-lunar-payload-services/",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-7d151be6",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Do not redistribute raw page/API content; cite source and preserve derived normalized values only after terms review.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Capture NASA program page, date, task-order references, provider, payload mass/context, and award amount where available.",
        "uncertaintyMode": "Task-order scope, modifications, mission risk, provider performance, and payload-specific services.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-4b3395cfcc70a4f4f0a78c7a0a54b16160a9808c0a58cd586d5085adf8dc28d7"
    },
    {
      "id": "source-use-review-nasa-cost-estimating-handbook",
      "sourceId": "nasa-cost-estimating-handbook",
      "title": "NASA Cost Estimating Handbook",
      "organization": "NASA",
      "url": "https://www.nasa.gov/reference/nasa-cost-estimating-handbook/",
      "trust": "primary",
      "sourceType": "cost-estimating-methodology",
      "sourceUseClass": "general-public-source",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-a82e1046",
      "sourceUseHash": "sha256-85a80d06f9389a1ef1c50bd568cb94482d3585d2fe47db58ce5ba9e88563bb11",
      "sourceRegistryHash": "fnv1a32-a82e1046",
      "requiredRightsArtifacts": [
        "terms or license note",
        "citation format",
        "access timestamp",
        "reviewer approval"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": false,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "NASA",
        "title": "NASA Cost Estimating Handbook",
        "url": "https://www.nasa.gov/reference/nasa-cost-estimating-handbook/",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-a82e1046",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Treat as citation-only planning evidence until source-specific terms are reviewed.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Document handbook version, estimating method, normalization year, risk treatment, and applied model assumptions.",
        "uncertaintyMode": "Method selection, analogy quality, learning curves, schedule risk, and normalization assumptions.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-56e69f036d914287fffd6d66631a065e6bae4dc48c8dd420b5c3c9d31774dd55"
    },
    {
      "id": "source-use-review-nasa-se-handbook",
      "sourceId": "nasa-se-handbook",
      "title": "NASA Systems Engineering Handbook",
      "organization": "NASA",
      "url": "https://www.nasa.gov/reference/systems-engineering-handbook/",
      "trust": "primary",
      "sourceType": "systems-engineering-methodology",
      "sourceUseClass": "general-public-source",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-991637e4",
      "sourceUseHash": "sha256-79a3344de218d982b0026380a394d25c1c9418417bf5a299c799e2a80ccbd436",
      "sourceRegistryHash": "fnv1a32-991637e4",
      "requiredRightsArtifacts": [
        "terms or license note",
        "citation format",
        "access timestamp",
        "reviewer approval"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": false,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "NASA",
        "title": "NASA Systems Engineering Handbook",
        "url": "https://www.nasa.gov/reference/systems-engineering-handbook/",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-991637e4",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Treat as citation-only planning evidence until source-specific terms are reviewed.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Document handbook version, review/maturity concept used, and mapping to scenario/process gates.",
        "uncertaintyMode": "Program-specific tailoring and maturity-assessment subjectivity.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-18529ac1902153e21a0a88567f0f81981664a8cc38ffe88ec4d78dacf1174d96"
    },
    {
      "id": "source-use-review-usaspending",
      "sourceId": "usaspending",
      "title": "USAspending.gov",
      "organization": "U.S. Treasury / federal agencies",
      "url": "https://www.usaspending.gov/",
      "trust": "primary",
      "sourceType": "federal-award-database",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-fb43b155",
      "sourceUseHash": "sha256-18f06378501568ad1ca153e06ca34d18481b416e9dec26668dccc2743a97f6b7",
      "sourceRegistryHash": "fnv1a32-fb43b155",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": false,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "U.S. Treasury / federal agencies",
        "title": "USAspending.gov",
        "url": "https://www.usaspending.gov/",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-fb43b155",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Preserve query filters, award id, recipient, agency, obligation amounts, date range, and retrieval hash.",
        "uncertaintyMode": "Award modification timing, obligation versus outlay, scope classification, and recipient hierarchy.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-44dc86020821ef71a9993b152b34d63c070a75752412776ee7bc52820d1b2f03"
    },
    {
      "id": "source-use-review-sec-edgar",
      "sourceId": "sec-edgar",
      "title": "SEC EDGAR",
      "organization": "U.S. Securities and Exchange Commission",
      "url": "https://www.sec.gov/edgar",
      "trust": "primary",
      "sourceType": "public-company-filings",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-f2e84204",
      "sourceUseHash": "sha256-811fbc05e0a75da2cd347130d23c8124d3491bf67fcb9a14784ab03ec0ae908a",
      "sourceRegistryHash": "fnv1a32-f2e84204",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": false,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "U.S. Securities and Exchange Commission",
        "title": "SEC EDGAR",
        "url": "https://www.sec.gov/edgar",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-f2e84204",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Preserve CIK/ticker, accession number, filing date, statement section, XBRL fields, and retrieval hash.",
        "uncertaintyMode": "Company-specific accounting policy, segment allocation, forward-looking statements, and market-cycle caveats.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-a1685dc32f2dd10822435e58b6aec9affcb7345f5e6c7f484161306061f35a14"
    },
    {
      "id": "source-use-review-ccsds",
      "sourceId": "ccsds",
      "title": "Consultative Committee for Space Data Systems",
      "organization": "CCSDS member agencies",
      "url": "https://ccsds.org/",
      "trust": "primary",
      "sourceType": "space-data-standard",
      "sourceUseClass": "standards-body-source",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-75fdfe19",
      "sourceUseHash": "sha256-662635bb0ff5db183a550d210208407fd3cb52181375ebfca24eb0db5a3c1c3c",
      "sourceRegistryHash": "fnv1a32-75fdfe19",
      "requiredRightsArtifacts": [
        "standard identifier and version",
        "license or public-access terms note",
        "citation format",
        "review of reproduction limits for tables, figures, and long excerpts"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "CCSDS member agencies",
        "title": "Consultative Committee for Space Data Systems",
        "url": "https://ccsds.org/",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-75fdfe19",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Use standard identifiers and short references; do not embed protected standards text without rights review.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Publication id, version, area, and applied assumption required.",
        "uncertaintyMode": "Standards conformance caveats and mission-specific implementation deltas.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-983afbacdf83a228cfa1c6fc2db8b2e2d02a058bae244539d7326936b048a586"
    },
    {
      "id": "source-use-review-nasa-spdf",
      "sourceId": "nasa-spdf",
      "title": "NASA Space Physics Data Facility",
      "organization": "NASA Goddard",
      "url": "https://spdf.gsfc.nasa.gov/",
      "trust": "primary",
      "sourceType": "heliophysics-data-archive",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-05f4400c",
      "sourceUseHash": "sha256-5740526eebb9601d64ebdad188c624842e80adc9b88de5bbf47232381464f0bc",
      "sourceRegistryHash": "fnv1a32-05f4400c",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": false,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "NASA Goddard",
        "title": "NASA Space Physics Data Facility",
        "url": "https://spdf.gsfc.nasa.gov/",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-05f4400c",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Dataset id, variables, time range, cadence, and retrieval hash required.",
        "uncertaintyMode": "Instrument calibration, cadence, and archive-version caveats.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-32c8135a41eab812aca7cd4d453b5cb352916ef453402ec0e20d158272024292"
    },
    {
      "id": "source-use-review-nasa-ccmc",
      "sourceId": "nasa-ccmc",
      "title": "Community Coordinated Modeling Center",
      "organization": "NASA Goddard",
      "url": "https://ccmc.gsfc.nasa.gov/",
      "trust": "primary",
      "sourceType": "space-weather-modeling-center",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-1a450de5",
      "sourceUseHash": "sha256-ef154fda79149df0df7ee8d1e84187eb1ed91c405e7bc4c98526a037f0c79dd2",
      "sourceRegistryHash": "fnv1a32-1a450de5",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": false,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "NASA Goddard",
        "title": "Community Coordinated Modeling Center",
        "url": "https://ccmc.gsfc.nasa.gov/",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-1a450de5",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Model, run id, inputs, version, and output hash required.",
        "uncertaintyMode": "Model validation state, run configuration, and uncertainty bounds.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-e9a3d92fa64992efdc7fcd16e058bcba03901b7b55667aa734eb373f75eed5fc"
    },
    {
      "id": "source-use-review-noaa-swpc",
      "sourceId": "noaa-swpc",
      "title": "NOAA Space Weather Prediction Center Products and Data",
      "organization": "NOAA/NWS",
      "url": "https://www.spaceweather.gov/products-and-data",
      "trust": "primary",
      "sourceType": "space-weather-products",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-dbbbdd09",
      "sourceUseHash": "sha256-c72eb81eee2fcbd6841b3d9d64f5d41580524d28860661c54c5a51448a479dff",
      "sourceRegistryHash": "fnv1a32-dbbbdd09",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": false,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "NOAA/NWS",
        "title": "NOAA Space Weather Prediction Center Products and Data",
        "url": "https://www.spaceweather.gov/products-and-data",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-dbbbdd09",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Product id, issue time, forecast horizon, and archive link required.",
        "uncertaintyMode": "Forecast horizon and product-specific verification notes.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-8286e8566447f45bb575f58049ee4b072c3969ecf091c32ce69e6015ba6b4b39"
    },
    {
      "id": "source-use-review-nist-chemistry-webbook",
      "sourceId": "nist-chemistry-webbook",
      "title": "NIST Chemistry WebBook SRD 69",
      "organization": "NIST",
      "url": "https://webbook.nist.gov/chemistry/",
      "trust": "primary",
      "sourceType": "chemistry-reference-database",
      "sourceUseClass": "standards-body-source",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-d9ac987b",
      "sourceUseHash": "sha256-16a6c3c35a922108b06ef50833ef43ebfbe6d1f662cf8cf5202e21ccc9558d5d",
      "sourceRegistryHash": "fnv1a32-d9ac987b",
      "requiredRightsArtifacts": [
        "standard identifier and version",
        "license or public-access terms note",
        "citation format",
        "review of reproduction limits for tables, figures, and long excerpts"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "NIST",
        "title": "NIST Chemistry WebBook SRD 69",
        "url": "https://webbook.nist.gov/chemistry/",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-d9ac987b",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Use standard identifiers and short references; do not embed protected standards text without rights review.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Species identifier, property table, units, citation, and access date required.",
        "uncertaintyMode": "NIST data notes, property method, and cited evaluation caveats.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-bc9c8a83702c167dc0dd82441e737366ee8b2330e009377b2b84f33256bbf71e"
    },
    {
      "id": "source-use-review-materials-project",
      "sourceId": "materials-project",
      "title": "Materials Project API",
      "organization": "Lawrence Berkeley National Laboratory / Materials Project",
      "url": "https://docs.materialsproject.org/downloading-data/using-the-api",
      "trust": "primary",
      "sourceType": "materials-property-api",
      "sourceUseClass": "public-data-or-api-source",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-c46b2daa",
      "sourceUseHash": "sha256-92083d9e756372d7fc89be368f9bd389c77c9bac73b02a46f14f11d1176acc21",
      "sourceRegistryHash": "fnv1a32-c46b2daa",
      "requiredRightsArtifacts": [
        "terms page or archive citation",
        "query URL/API parameters",
        "raw payload hash",
        "normalized record hash",
        "citation and attribution note"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": false,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "Lawrence Berkeley National Laboratory / Materials Project",
        "title": "Materials Project API",
        "url": "https://docs.materialsproject.org/downloading-data/using-the-api",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-c46b2daa",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Use reviewed normalized records; do not redistribute raw payloads or imply provider endorsement without rights review.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "mp-id, fields, API version/client, method metadata, and retrieval hash required.",
        "uncertaintyMode": "DFT/method limitations, provenance, and contributed-data caveats.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-4596c7e86467c7e6d0114d13df988db5a8376ff3ee9a04436f439191d0725ec5"
    },
    {
      "id": "source-use-review-cantera",
      "sourceId": "cantera",
      "title": "Cantera",
      "organization": "Cantera project",
      "url": "https://cantera.org/",
      "trust": "open-source",
      "sourceType": "chemistry-transport-toolkit",
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-883bdb34",
      "sourceUseHash": "sha256-50a5dfe354dc940b42f8eeeadfd4bb9013a3ad7d35cfe907e00b74566ad2fe09",
      "sourceRegistryHash": "fnv1a32-883bdb34",
      "requiredRightsArtifacts": [
        "license file or SPDX identifier",
        "dependency version and repository URL",
        "notice/attribution requirement",
        "copyleft or redistribution compatibility review"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": false,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "Cantera project",
        "title": "Cantera",
        "url": "https://cantera.org/",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-883bdb34",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Do not bundle, modify, or redistribute tool code/artifacts until the specific license and notices are captured.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Mechanism file, tool version, inputs, outputs, and mechanism hash required.",
        "uncertaintyMode": "Mechanism validity range and solver tolerance.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-f8c02fcec876f0727bd2a3dd2898bfa468e397fbb04f5211bbbbcca27945f453"
    },
    {
      "id": "source-use-review-moose-framework",
      "sourceId": "moose-framework",
      "title": "MOOSE Framework",
      "organization": "Idaho National Laboratory",
      "url": "https://mooseframework.inl.gov/",
      "trust": "primary",
      "sourceType": "multiphysics-framework",
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-a9482599",
      "sourceUseHash": "sha256-8238d3e76b4f3780f90dc80a602bf63d758347ab8134d282a19c78628cf4f75a",
      "sourceRegistryHash": "fnv1a32-a9482599",
      "requiredRightsArtifacts": [
        "license file or SPDX identifier",
        "dependency version and repository URL",
        "notice/attribution requirement",
        "copyleft or redistribution compatibility review"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": false,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "Idaho National Laboratory",
        "title": "MOOSE Framework",
        "url": "https://mooseframework.inl.gov/",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-a9482599",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Do not bundle, modify, or redistribute tool code/artifacts until the specific license and notices are captured.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Input file, application/version, mesh hash, material data, and output hash required.",
        "uncertaintyMode": "Discretization, mesh convergence, solver residuals, and material uncertainty.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-091da51fce102c99c05e3b43636be9a9a0d0b709fbd0950ae741ad065156e656"
    },
    {
      "id": "source-use-review-openfoam",
      "sourceId": "openfoam",
      "title": "OpenFOAM",
      "organization": "OpenCFD / OpenFOAM community",
      "url": "https://www.openfoam.com/",
      "trust": "open-source",
      "sourceType": "cfd-toolkit",
      "sourceUseClass": "open-source-tool-or-code",
      "riskLevel": "medium",
      "priority": "P2",
      "reviewState": "blocked-review-packet-open",
      "allowedCurrentUse": "Internal research planning, source discovery, and hash-backed citation context only; not legal clearance.",
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "sourceRecordHash": "fnv1a32-124056ab",
      "sourceUseHash": "sha256-5ef7497b07d3f325ac1ea3c70735459b841d21a61fba9819a27f73539e75bcb0",
      "sourceRegistryHash": "fnv1a32-124056ab",
      "requiredRightsArtifacts": [
        "license file or SPDX identifier",
        "dependency version and repository URL",
        "notice/attribution requirement",
        "copyleft or redistribution compatibility review"
      ],
      "requiredDecisionSet": [
        {
          "id": "terms-license-capture",
          "label": "Terms/license capture",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "termsUrl",
            "capturedAt",
            "termsHash",
            "licenseNote",
            "reviewer"
          ]
        },
        {
          "id": "citation-attribution",
          "label": "Citation and attribution policy",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "citationText",
            "providerName",
            "accessDate",
            "normalizedRecordHash"
          ]
        },
        {
          "id": "raw-payload-redistribution",
          "label": "Raw payload redistribution decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "rawPayloadAllowed",
            "rawPayloadScope",
            "sourceTermsReference"
          ]
        },
        {
          "id": "derived-record-customer-use",
          "label": "Derived record customer-use decision",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "customerUseAllowed",
            "allowedUseScope",
            "excludedUses",
            "reviewerApproval"
          ]
        },
        {
          "id": "provider-endorsement-boundary",
          "label": "Provider endorsement boundary",
          "required": true,
          "status": "missing",
          "evidenceFields": [
            "providerMarksAllowed",
            "endorsementDisclaimer",
            "brandUseDecision"
          ]
        },
        {
          "id": "excerpt-and-table-boundary",
          "label": "Excerpt/table reproduction boundary",
          "required": false,
          "status": "missing",
          "evidenceFields": [
            "excerptLimit",
            "tableReuseAllowed",
            "figureReuseAllowed"
          ]
        }
      ],
      "citationDraft": {
        "provider": "OpenCFD / OpenFOAM community",
        "title": "OpenFOAM",
        "url": "https://www.openfoam.com/",
        "capturedAt": "2026-06-19",
        "normalizedRecordHash": "fnv1a32-124056ab",
        "boundary": "Cite source title, provider, URL, access/capture date, and normalized record hash. Do not imply provider endorsement."
      },
      "redistributionBoundary": "Do not bundle, modify, or redistribute tool code/artifacts until the specific license and notices are captured.",
      "reviewInputs": {
        "declaredLicenseNote": "Public-source review required before redistribution of raw payloads.",
        "queryPolicy": "Case directory hash, solver/version, mesh, boundary conditions, and result hash required.",
        "uncertaintyMode": "Mesh convergence, turbulence model, chemistry model, and boundary-condition uncertainty.",
        "metadataCoverage": 100
      },
      "reviewOutputsRequired": {
        "termsHash": null,
        "licenseDecision": null,
        "citationApproval": null,
        "rawRedistributionDecision": null,
        "customerUseDecision": null,
        "providerEndorsementDecision": null,
        "reviewer": null,
        "reviewedAt": null
      },
      "blockers": [
        "Source-specific license or terms artifact is not captured.",
        "Source-use reviewer approval is not recorded.",
        "Raw source payload redistribution is not allowed by this ledger.",
        "Customer/commercial use is blocked until rights review passes.",
        "No source-use review packet has captured terms/license evidence.",
        "No reviewer has approved customer-facing use, redistribution scope, or citation text."
      ],
      "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
      "packetHash": "sha256-f266f1115629723670abec47ba0b67c47760f49e4f07ba4a28621447372660b9"
    }
  ],
  "packetHash": "sha256-510164d326f7598c8543b02a29a8d1aff756b61ea192e1f239b877aace4c6864"
}
;
